import { render, staticRenderFns } from "./TomaFicha.vue?vue&type=template&id=cb098ef0&scoped=true"
import script from "./TomaFicha.vue?vue&type=script&lang=js"
export * from "./TomaFicha.vue?vue&type=script&lang=js"
import style0 from "./TomaFicha.vue?vue&type=style&index=0&id=cb098ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb098ef0",
  null
  
)

export default component.exports